var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{style:({ backgroundColor: _vm.bgColor }),attrs:{"id":"inspire"}},[(_vm.logged)?_c('Navigation'):_c('LoginPage'),_c('v-main',[(_vm.logged)?_c('v-container',{attrs:{"fluid":""}},[_c('router-view')],1):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }